import { jsxs as l, jsx as C } from "react/jsx-runtime";
function t(r) {
  return /* @__PURE__ */ l("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M17.7581 17.5563H8.01977C7.90818 17.5563 7.81688 17.6563 7.81688 17.7785V20.8891C7.81688 21.2001 7.91832 21.4668 8.11106 21.6778C8.3038 21.8889 8.54726 22 8.8313 22H16.9466C17.2306 22 17.4741 21.8889 17.6668 21.6778C17.8596 21.4668 17.961 21.2001 17.961 20.8891V17.7785C17.961 17.6563 17.8697 17.5563 17.7581 17.5563Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M19.5638 2.41455C19.1682 1.98129 18.732 1.9924 17.961 2.00351H8.72986C7.71544 2.00351 7.38069 2.12571 7.12708 2.41455C6.91405 2.64784 6.75175 2.91446 6.75175 4.22535V5.7473C6.75175 5.7473 7.82703 4.81413 5.69676 5.7473C5.31128 5.91394 4.68234 5.7473 5.18955 7.41367L5.69676 10.191L6.60973 15.3345C6.66045 15.6678 6.80247 15.9344 7.02564 16.1344C7.24881 16.3343 7.5227 16.4454 7.82703 16.4454H17.9712C18.2755 16.4454 18.5392 16.3454 18.7726 16.1344C18.9957 15.9344 19.1377 15.6678 19.1885 15.3345L19.9493 11.113C19.9797 11.0242 20 10.9464 20 10.8908V4.22535C19.8986 2.93668 19.787 2.64784 19.5739 2.41455H19.5638ZM17.961 10.4243C17.961 10.4243 17.961 10.4465 17.961 10.4687L17.3321 14.0458C17.3118 14.1458 17.2306 14.2236 17.1292 14.2236H8.63856C8.53712 14.2236 8.45596 14.1458 8.43568 14.0458L7.80674 10.4465V7.55809H8.82115V4.44753C8.82115 4.32533 8.91245 4.22535 9.02404 4.22535H17.748C17.8596 4.22535 17.9509 4.32533 17.9509 4.44753V10.4243H17.961Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M14.3091 9.63551H12.2803C11.8543 9.63551 11.4992 9.46887 11.205 9.1467C10.9108 8.82454 10.7587 8.42461 10.7587 7.96913C10.7587 7.51366 10.9108 7.11373 11.205 6.79156C11.4992 6.4694 11.8644 6.30276 12.2803 6.30276H14.3091C14.7352 6.30276 15.0902 6.4694 15.3844 6.79156C15.6786 7.11373 15.8308 7.51366 15.8308 7.96913C15.8308 8.42461 15.6786 8.82454 15.3844 9.1467C15.0902 9.46887 14.725 9.63551 14.3091 9.63551Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  t as default
};
